export const PROJECTS = [
    {
        projectName : "Movie Director Api / NodeJS",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/node-movie-api-min.png',
        projectLink: "https://github.com/besyuzkirk/node-movie-api"
    },
    {
        projectName : "Expense Tracker / Flutter",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/expensetracker-min.png',
        projectLink: "https://github.com/besyuzkirk/ExpensTracker49MFinalProject"
    },
    {
        projectName : "Password Generator / Android SDK",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/password-generator-min.png',
        projectLink: "https://github.com/besyuzkirk/extrasimple-password-generator"
    },
    {
        projectName : "E-commerce App / Django",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/djangomvc-min.png',
        projectLink: "https://github.com/besyuzkirk/django-ecommerce-simple"
    },
    {
        projectName : "N-Layer Product Api / ASP.NET Core",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/postman.png',
        projectLink: "https://github.com/besyuzkirk/ASP.NET-Core-6---WEB-API"
    },
    {
        projectName : "Dice Roller / Android SDK",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/dice-min.png',
        projectLink: "https://github.com/besyuzkirk/dice-roller-bugroid"
    },
    {
        projectName : "Personel Web Page / Vanilla Javascript",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/webpage-min.png',
        projectLink: "https://github.com/besyuzkirk/ahmetkarademir"
    },
    {
        projectName : "To-Do App / Vanilla Javascript",
        projectImg: process.env.PUBLIC_URL + '/images/portfolio/todo-min.png',
        projectLink: "https://github.com/besyuzkirk/js-todoApp-localStorage"
    },
   
]